
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.47 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4.44 4c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.483 12.483 0 0 1-2.67-2 12.832 12.832 0 0 1-2-2.66L10 9a2 2 0 0 0 1-2.48 10.337 10.337 0 0 1-.39-1.31c-.05-.23-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-2.24 1 3 3 0 0 0-.73 2.39A19 19 0 0 0 18 21.91c.13.01.26.01.39 0a3 3 0 0 0 3-3v-3A3 3 0 0 0 18.91 13Zm.49 6a.999.999 0 0 1-1.15 1 17.12 17.12 0 0 1-9.87-4.85 17.14 17.14 0 0 1-4.84-9.93 1 1 0 0 1 .25-.82 1 1 0 0 1 .74-.34h3a1 1 0 0 1 1 .79c.04.273.09.543.15.81.116.527.27 1.045.46 1.55l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .56-.52l.63-1.4c.517.185 1.045.338 1.58.46.26.06.54.11.81.15a1 1 0 0 1 .78 1L19.4 19Z","fill":"currentColor"}})])
          )
        }
      }
    